import React from 'react';

const ProductSection = () => {
  return (
    <section className="product-section" id="product" style={{ padding: '4rem 0', backgroundColor: '#f9fafb' }}>
      <div className="value-container">
        <div className="section-header">
          <span className="section-label">Why Ferritico</span>
          <h2 className="section-title">Your AI-Driven Virtual Metallurgist</h2>
        <div className="section-subtitle" style={{ textAlign: 'left', padding: '0px 15px 0px 15px' }}>
          <p style={{ }}>
            Ferritico is an AI-driven steel simulation software that acts like a virtual metallurgist on your team.
            <br />
            Our models are trained on decades of real steel experimental data and capture complex metallurgical relationships that traditional methods can miss.
            The result is more reliable, data-driven guidance for alloy design, heat treatment, and process decisions.
            <br />
            Ferritico can also support downstream engineering workflows by providing inputs for FEM simulations and related tools.
          </p>
        </div>
      </div>
      </div>
    </section>
  );
};

export default ProductSection;
